module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Box1-6fd4cf63b777d8f733ad599b4fe9b9fe.svg";